import React from "react";
import isEmpty from "lodash/isEmpty";
import {
  AccordionDetail,
  AccordionItem,
  AccordionTitle,
  AccordionSubTitle,
} from '@vds/accordions'
import { Text } from '@vds/core';
import { MarginSpacerM } from "common/components/styleTag";
import {
  ProductBorder,
  ProductTitle,
  ProductSubTitle,
  CustomAccordionHeader,
  AccordionPlaceholder,
} from "../../styles";

const PDPAccordionSection = ({
  id,
  opened,
  setOpened,
  titleText,
  subTitleText,
  offerText,
  showOfferText = false,
  showSubTitleWhenOpened,
  children,
  dataTrack,
  isfromShoppingCart,
  disable = false,
  refProp,
  bold = true,
  isStickyButton,
  ...props
}) => {
  return disable ? (
    <ProductBorder isfromShoppingCart={isfromShoppingCart} ref={refProp} isStickyButton={isStickyButton} id={id}>
      <AccordionPlaceholder>
        <Text kind="title" bold={bold}size="medium">
          {titleText}
        </Text>
        <MarginSpacerM />
        <Text kind="body" size="large">{isEmpty(subTitleText) ? "" : subTitleText}</Text>
      </AccordionPlaceholder>
    </ProductBorder>
  ) : (
    <ProductBorder isfromShoppingCart={isfromShoppingCart} ref={refProp} isStickyButton={isStickyButton} id={id}>
      <AccordionItem data-track={dataTrack} opened={opened}>
        <CustomAccordionHeader
          onClick={(e) => setOpened(!opened)}
          triggerType="icon"
        >
          <AccordionTitle>
            <ProductTitle className="productTitle">
              <Text kind="title" size="small" bold titleBold>{titleText}</Text>
            </ProductTitle>
            {(!opened || showSubTitleWhenOpened) && (
              <AccordionSubTitle>
                <ProductSubTitle>
                  {(isEmpty(subTitleText) || String(subTitleText).toLowerCase().includes('undefined')) ? "" : subTitleText}
                </ProductSubTitle>
              </AccordionSubTitle>
            )}
          </AccordionTitle>
        </CustomAccordionHeader>
        <AccordionTitle>
        {(offerText  && showOfferText && opened) ? <Text kind="body" size="large">{offerText}</Text> : <></>}
        </AccordionTitle>
        <AccordionDetail>{children}</AccordionDetail>
      </AccordionItem>
    </ProductBorder>
  );
};

export default PDPAccordionSection;
